/** Reader-supplied clarification response contract. */

export type AskHelixInputResponseValueDto =
  | Readonly<{ kind: 'typed_value'; value: string | number | boolean }>
  | Readonly<{ kind: 'policy_choice'; option: string }>
  | Readonly<{ kind: 'clarification'; text: string }>
  | Readonly<{ kind: 'approval'; approved: boolean }>
  | Readonly<{ kind: 'assumption_authorization'; authorized: boolean }>
  | Readonly<{ kind: 'objective_revision' }>;

/** Client envelope. Tenant, actor, and every other scope field are server-derived. */
export type AskHelixInputResponseDto = Readonly<{
  requestId: string;
  runId: string;
  claimedObjectiveDigest: string;
  value: AskHelixInputResponseValueDto;
}>;

export const ASK_HELIX_INPUT_RESPONSE_DTO_FIELDS = [
  'requestId',
  'runId',
  'claimedObjectiveDigest',
  'value',
] as const;

/**
 * Closed resume outcomes: mirrors ManagerResumeErrorCode in manager-run-resume.ts,
 * then adds the #5779 run-slot and malformed-boundary outcomes.
 */
export const ASK_HELIX_RESUME_REJECTION_REASONS = [
  'unknown_pending_request',
  'identity_scope_mismatch',
  'objective_digest_mismatch',
  'evidence_upload_not_supported_here',
  'response_kind_mismatch',
  'response_option_not_offered',
  'objective_revision_not_supported',
  'run_superseded',
  'run_expired',
  'malformed_response',
] as const;

export type AskHelixResumeRejectionReasonDto =
  (typeof ASK_HELIX_RESUME_REJECTION_REASONS)[number];
